import React, { Component } from 'react'; // eslint-disable-line
import {
    Link,
} from 'react-router-dom';
import moment from 'moment';
import YesNoDialog from '../common/YesNoDialog';
import DeleteDialog from '../common/DeleteDialog';
import CloseX from '../svg/CloseX';
import i18n from '../../i18n';
import StatusCircle from '../svg/StatusCircle';

class ProjectItem extends Component {
    constructor(props) {
        super(props);

        this.deleteProject = this.deleteProject.bind(this);
        this.openConfirmDialog = this.openConfirmDialog.bind(this);
        this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
        this.state = {
            confirmDelete: false,
        };
    }

    deleteProject() {
        this.props.deleteProject(this.props.project.id, this.props.project.latestVersion.id);
        this.closeConfirmDialog();
    }

    openConfirmDialog() {
        this.setState({ confirmDelete: true });
    }

    closeConfirmDialog() {
        this.setState({ confirmDelete: false });
    }

    checkForLogo = (logoUrl, church) => {
        const isUnity = localStorage.getItem('IsUnity') === 'true';
      
        if (!isUnity || !logoUrl || logoUrl === 'null') {
          return <h5 className="logo-placeholder">{church}</h5>;
        }
      
        return <img alt={church} title={church} src={logoUrl} />;
      };
      

    render() {
        const {
            project,
            church,
        } = this.props;

        const logoUrl = localStorage.getItem('ChurchLogo');
        const defaultLogo = this.checkForLogo(logoUrl, church);

        const version = project && project.latestVersion ? project.latestVersion : {};
        const dateModifiedObj = new Date(project.dateModified);
        const dateModified = moment(dateModifiedObj).format('MMM DD, YYYY');
        const dateModifiedtext = `Modified: ${dateModified}`;
        let deleteConfirmModal = '';
        if (this.state.confirmDelete) {
            deleteConfirmModal = (
                <YesNoDialog
                    Message={<DeleteDialog open={i18n.t('projects.delete1')} message={`This will delete ${version.name ? version.name : 'Untitled Project'} along with all of its content. Are you sure you want to proceed?`} name={version.name ? `${version.name}` : i18n.t('projects.null')} warning={i18n.t('projects.delete2')} />}
                    ExecuteAction={this.deleteProject}
                    CloseDialog={this.closeConfirmDialog}
                    Visible={this.state.confirmDelete}
                    YesText={i18n.t('delete')}
                    NoText={i18n.t('cancel')}
                    title="Delete Project?"
                />
            );
        }

        return (
            <div data-qa={`${project.id}`} id={`project-${project.id}`} className="project-list__project">
                <div className={project.liveVersion ? 'live project-info-wrap' : 'project-info-wrap'}>
                    {/* eslint-disable-next-line */}
                    <div data-qa={`project-${project.id}-delete`} className="delete-project" onClick={this.openConfirmDialog}><CloseX /></div>
                    {project.liveVersion && !project.latestVersion.sameAsLive
                        && (
                            <div data-qa={`project-${project.id}-modified-circle`} className="live-status modified">
                                <span className="circle"><StatusCircle color="#ffc82c" /></span>
                                {i18n.t('live')}
                                {' '}
                                <p>{i18n.t('unpublished-changes')}</p>
                            </div>
                        )}
                    {project.liveVersion && project.latestVersion.sameAsLive
                        && (
                            <div data-qa={`project-${project.id}-live-circle`} className="live-status">
                                <span className="circle"><StatusCircle color="#2ad786" /></span>
                                {i18n.t('live')}
                            </div>
                        )}
                    <Link to={`/projects/${project.id}/general-info`}>
                        <div data-qa={`project-${project.id}-logo`} className="logo">
                            {project.latestVersion.logoImage !== null ? <img alt="" src={`${project.latestVersion.logoImage.imagePath}`} /> : defaultLogo}
                        </div>
                        <div data-qa={`project-${project.id}-created-date`} className="created-date">{project.liveVersion && !project.latestVersion.sameAsLive ? dateModifiedtext : dateModified}</div>
                        <h5 data-qa={`project-${project.id}-version-name`}><span>{version.name ? version.name : 'Untitled Project'}</span></h5>
                    </Link>
                </div>
                <div className="delete-modal">
                    {deleteConfirmModal}
                </div>
            </div>
        );
    }
}

export default ProjectItem;
